import {observer} from "mobx-react";
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton, InputAdornment, MenuItem, Select, SelectChangeEvent, TextField,
    Typography
} from "@mui/material";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import React, {useEffect, useState} from "react";
import {useStore} from "../../../stores/Store";
import Grid from "@mui/material/Unstable_Grid2";
import CloseIcon from "@mui/icons-material/Close";
import RollingCredit from "./RollingCredit";
import CreateRollingCredit from "./CreateRollingCredit";
import ukFlag from "../../../assets/img/united-kingdom-flag-png-xl.png";
import ruFlag from "../../../assets/img/russia-flag.png";
import geFlag from '../../../assets/img/german-flag.png'
import frFlag from '../../../assets/img/france-flag.png'
import {defaultSetting, Setting} from "../../../models/Setting";

export default observer(() => {
    const { UserStore, CreditTextsStore, LanguageStore, SettingsStore  } = useStore();
    const { findByName, update } = SettingsStore
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [language, setLanguage] = useState<'ge' | 'en' | 'fr' | 'ru'>(LanguageStore.currentLanguage);
    const [speedSetting, setSpeedSetting] = useState<Setting>(defaultSetting)
    const [speedIsLoading, setSpeedIsLoading] = useState<boolean>(true)

    useEffect(() => {
        setLanguage(LanguageStore.currentLanguage)
    }, [LanguageStore.currentLanguage]);

    useEffect(() => {
        const speedSetting = findByName(`creditTextSpeed${language}`);
        if(!isNaN(parseInt(speedSetting.value))) setSpeedSetting(speedSetting)
        setSpeedIsLoading(false);
    }, [language, CreditTextsStore.isLoading]);

    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);
    
    const onChangeSpeed = (event: any) => {
        const newSpeedSetting = {name: speedSetting.name, id: speedSetting.id, value: event.target.value}
        setSpeedSetting(newSpeedSetting);
    }
    
    const updateSpeed = async () => {
        setSpeedIsLoading(true)       
        await update(speedSetting)
        setSpeedIsLoading(false);
    }

    return !UserStore.isLoggedIn ? null : (
        <>
            <IconButton
                size={'small'}
                onClick={handleOpen}
            >
                <ModeEditIcon />
            </IconButton>
            <Dialog open={isOpen} fullScreen>
                <DialogTitle>
                    <Grid sx={{justifyContent: 'space-between'}} container>
                        <Grid>
                            <Typography variant={'h6'} sx={{mt: 0.5}}>{LanguageStore.currentLanguageMessages.RollingCredits.DialogTitle}</Typography>
                        </Grid>
                        <Grid>
                            <Select
                                value={language}
                                //@ts-ignore
                                onChange={(event: SelectChangeEvent) => setLanguage(event.target.value as string)}
                            >
                                <MenuItem value={'ge'}>
                                    <img src={geFlag} className={'languageFlag'}/>
                                </MenuItem>
                                <MenuItem value={'en'}>
                                    <img src={ukFlag} className={'languageFlag'}  />
                                </MenuItem>
                                <MenuItem value={'ru'}>
                                    <img src={ruFlag} className={'languageFlag'}/>
                                </MenuItem>
                                <MenuItem value={'fr'}>
                                    <img src={frFlag} className={'languageFlag'}/>
                                </MenuItem>
                            </Select>
                        </Grid>
                        <Grid>
                            <IconButton
                                onClick={handleClose}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{justifyContent: 'right', w: '100%', display: 'flex'}}>
                        <TextField 
                            label={LanguageStore.currentLanguageMessages.GeneralComponentLabels.speed}
                            type={'number'}
                            variant={'filled'}
                            value={(isNaN(parseInt(speedSetting.value))) ? 0 : parseInt(speedSetting.value)}
                            onChange={onChangeSpeed}
                            onBlur={updateSpeed}
                            disabled={speedIsLoading}
                            InputProps={{
                                endAdornment: <InputAdornment position={'end'}>
                                    { speedIsLoading && <CircularProgress color={'secondary'} size={16} sx={{mr: 2}}/> }
                                </InputAdornment>}}
                            sx={{width: 200}}
                        />
                    </Box>
                    {
                        CreditTextsStore.isLoading ?
                            <Box sx={{width: '100%', justifyContent: 'center', height: '100%', alignItems: 'center', display: 'flex'}}>
                                <CircularProgress color={'secondary'} />
                            </Box> :
                            <Box>
                                {
                                    CreditTextsStore.creditTexts
                                        .filter(cr => cr.language === language)
                                        .map(cr =>
                                            <RollingCredit key={`${cr.order}_${cr.id}`} creditText={cr}/>
                                    )
                                }
                                <CreateRollingCredit language={language} />
                            </Box>
                    }
                </DialogContent>
                <DialogActions>
                    <Button
                        startIcon={<CloseIcon />}
                        onClick={handleClose}
                    >
                        {LanguageStore.currentLanguageMessages.GeneralComponentLabels.closeButtonLabel}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
})